<template>
  <div :class="activateLoading ? 'abtg_loading-overlay ' : ''">
    <span class="abtg_loading-text" v-if="activateLoading">
      {{ $t("mapping.text_ricalcolo") }} &nbsp;
      <i class="fas fa-sync-alt loading fa-spin"></i>
    </span>

    <n-delete
        @closeModal="closeModal"
        @deleteResource="deleteResource"
    ></n-delete>
    <n-deletef
        @closeModal="closeModal"
        @deleteFolder="setFolderForDelete"
    ></n-deletef>
    <n-create
        @closeModal="closeModal"
        @createFolder="createFolder"
        v-bind:content="{meditFolder:editFolder, folderName:localfolderName}">
    </n-create>

    <n-modal-zone
        v-if="zoneInfo"
        v-bind:content="{ formData: zoneInfo }"
        @editZoneData="editZoneData"
        @closeModal="closeModal"
    ></n-modal-zone>
    <n-modal-building
        v-if="formData"
        v-bind:content="{ formData: formData, myError: myError }"
    ></n-modal-building>
    <n-range
        @rangeData="saveCustomRangeData"
        @deleteCustomRange="deleteCustomRange"
        @closeModal="closeModal"
        v-bind:content="{ customRange: customRange }"
    ></n-range>

    <n-bread v-bind:content="{ bread_list, bread_active }"></n-bread>

    <div class="row">
      <div class="col-lg-3">
        <div class="form-group">

          <select
              class="form-control"
              v-model="selectedZone"
              @change="goToUrl('0')"
              id="exampleFormControlSelect1"
              style="font-size: 140%; font-weight: bold;height: 45px"

          >
            <option
                v-for="(r, index) in orderedRegionList"
                :value="{ cityId: r.city_id, city: r.city }"
            >
              {{ r.city }} ({{ r.zoneNumber }})
            </option>
          </select>

        </div>
      </div>
      <div class="col-lg-3">
        <div class="form-group">
          <select class="form-control" v-model="localfolderId" name="folder" id="folderId"
                  @change="goToUrl(localfolderId)" style="height: 45px">
            <option :value="0" @click="goToUrl('0')" class="font-weight-bold">
              {{ $t("mapping.first_folder") }}
            </option>
            <option v-for="folder in this.allFolder" :key="folder.id" :value="folder.id">
              {{ folder.name }}
            </option>


          </select>

        </div>
      </div>
      <div class="col-lg-3">

      </div>
      <div class="col-lg-3">

      </div>
    </div>


    <div class="row mx-2">


      <hr class="abtg__hr-folder">
      <div v-if="localfolderId>0">
        <i class="far fa-folder mr-2 abtg-smallzone"></i>
        <span class="abtg-smallzone">{{ this.localfolderName }}</span>
        <span>




          <a @click="showModal('m-createFolder', 'old')">
            <span  class="fa-stack">
              <i class="fas fa-circle fa-stack-2x" style="color: #c6c5c5"></i>
             <i class="fas fa-pencil-alt fa-stack-1x"></i>
            </span>

          </a>
        </span>
        <span>
          <a @click="showModal('m-deletef')">
            <span  class="fa-stack">
              <i class="fas fa-circle fa-stack-2x" style="color: #c6c5c5"></i>
              <i class="fas fa-trash-alt fa-stack-1x" ></i>
            </span>

          </a>
        </span>
      </div>


    </div>

    <div class="row mt-3" style="padding-left: 8px;">


      <div
          class="abtg-singlezone d-inline-flex justify-content-between col-lg-2 mx-3"
          :id="z && z.zone ? `abtg-singlezone-${z.zone.toLowerCase()}` : ''"
          v-for="(z, index) in zoneFolderList"
          :key="z.id"
          :class="
              isThisLinkActive({
                zone: z.zone,
                macrozone: z.macrozone,
                microzone: z.microzone,
              })
            "
      >
        <a
            :href="`#${showZoneNameHashtag(z)}`"
            :id="showZoneNameHashtag(z)"
            @click="[removeAllSelectedZones(), buildingByZone({ z, index })]"
        >{{ showZoneName(z) }}</a
        >

        <input type="checkbox" v-model="zoneChecked" :value="z.id" :id="z.id">

      </div>

    </div>

    <div class="row mt-3" style="padding-left: 8px;">
      <div class="col-12" style="
    padding-left: 0px;">
        <div class="tools ml-3">
          <div class="btn-group dropright" role="group">
            <a
                id="folderGroup"
                type="button"
                style="margin-top: -3px; padding-right: 30px; color: white !important;text-decoration: underline;"
                class="abtg-all-zones cursor-pointer	"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
            >{{ $t("mapping.move") }}</a>
            <div class="dropdown-menu" aria-labelledby="mapGroup">


              <a
                  v-for="folder in this.allFolder"
                  class="dropdown-item"
                  @click="changeFolderlocal(folder.id)"
              ><i class="fas fa-folder"></i>
                {{ folder.name }}

              </a>

              <a

                  class="dropdown-item font-weight-bold"
                  @click="showModal('m-createFolder', 'new')"
              >{{ $t("mapping.add_folder") }}</a
              >

            </div>
          </div>
        </div>
      </div>
    </div>
    <hr class="abtg__hr-folder my-3">


    <div class="row">

    </div>


    <!-- building list by zone -->
    <transition name="fade" mode="out-in">
      <div
          class="
          card
          abtg__default-card abtg__default-card-border abtg-card-mapping
        "
      >
        <div
            class="card-head"
            v-show="showMappingListCard"
            style="
            text-transform: none !important;
            font-weight: normal !important;
          "
        >
          <header>
            <span class="abtg-smallzone">{{ city }}</span>
            <span v-if="zoneInfo && !showAllZonesInOne" class="abtg-smallzone">
              | {{ zoneInfo.zone }} |
              <span>{{ zoneInfo.macrozone }} | {{ zoneInfo.microzone }}</span>
            </span>
          </header>




          <div v-if="!showAllZonesInOne" class="abtg__header_popover">
            <n-popover
                module="mapping"
                content="list"
                position="right"
            ></n-popover>
          </div>

          <!--Trades-->



          <!--End Trades-->




        </div>

        <div class="card-body" v-if="(zoneInfo && zoneInfo.latlng) || zoneListOfCity">

          <!-- MAP Google -->








          <!-- END Google -->

          <!-- price and street price -->

          <br/>

          <div style="padding:20px; background-color: #efefef">
            <div v-if="tradeMap">
              <mappa
                  :zoneInfo="zoneInfo"
              >
              </mappa>
            </div>
          </div>
          <!-- tab mq -->

          <!-- end tab mq -->

          <!-- // end subheader -->


        </div>



      </div>
    </transition>
    <!-- end building list by zone -->
  </div>
</template>
<script>
import NBread from "@/partials/bread";
import NPopover from "@/partials/popover";
import NRange from "@/partials/mapping/modal_range";
import NModalBuilding from "@/partials/mapping/modal_building";
import NGmap from "@/partials/mapping/gmap";
import NDelete from "@/partials/modal_delete";
import NDeletef from "@/partials/modal_deletefolder";
import NCreate from "@/partials/modal_createFolder";
import mappa from "@/partials/clickMap/mappa"
import NModalZone from "@/partials/mapping/modal_zone";
import {mixin} from "@/helpers/helper";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

export default {
  mixins: [mixin],
  components: {
    NBread,
    NPopover,
    NRange,
    NModalBuilding,
    NGmap,
    NDelete,
    NDeletef,
    NModalZone,
    NCreate,
    mappa
  },

  data() {
    return {
      more: true,
      selectedZone: {},
      nameFolder: "",
      editFolder: false,
      zoneChecked: [],
      localfolderId: 0,
      localfolderName: "",
      showFolderModal: false,
      i: 0,
      tradeMap: true,
      standardMap: false

    };
  },

  created() {
    this.lang = window.localStorage.getItem("language");

    if (this.lang === "es") {
      this.SET_DATA({
        name: "bread_active",
        data: {label: "Atti di vendita"},
      });
    } else {
      this.SET_DATA({
        name: "bread_active",
        data: {label: "Atti di vendita"},
      });
    }

    this.regionByUser();


    if (this.handleUrl('cityId') === null && this.handleUrl('city') === null) {
      this.lastMapping({route: this.$route});

    } else {
      this.changeZoneByUrl();
    }

    setTimeout(() => {
      this.allFolderByCity();
    }, 1000)


  },

  watch: {
    zoneInfo(val) {
      if (
          val &&
          Object.keys(val).length > 0 &&
          Object.keys(this.selectedZone).length === 0
      ) {
        this.selectedZone = {
          cityId: val.m_cities.id,
          city: val.m_cities.comune,
        };
      }
    },

    streetPriceSaved(oldValue, newValue) {
      if (oldValue != newValue) {
        this.$router.push({path: "/auction"});
      }
    },

    selectedZone(value) {
      // if (!this.startLastMapping) {
      //  // this.zoneByCity(value);
      // }


      this.SET_DATA({
        name: "startLastMapping",
        data: false,
      });
    },

    zoneList(value) {
      if (this.$route.params.zone_id) {
        this.setMappingZone({id: this.$route.params.zone_id});
      }

      setTimeout(() => {
        this.checkIfHasExist();
      }, 500);
    },

  },
  computed: {
    ...mapState("n_mapping", [
      "bread_active",
      "bread_list",
      "regionList",
      "zoneList",
      "zoneListOfCity",
      "buildingList",
      "streetPrice",
      "customRange",
      "ac",
      "customAc",
      "formData",
      "myError",
      "showMappingListCard",
      "closeAfterSave",
      "city",
      "cityId",
      "zoneInfo",
      "componentKey",
      "cityAc",
      "zoneAc",
      "buildingType",
      "rotateColorSpin",
      "rotateSpin",
      "showBinIcon",
      "showAllZonesInOne",
      "activeAllZone",
      "idZoneToDelete",
      'idNotClone',
      "startLastMapping",
      "forcePageRefresh",
      "activateLoading",
      "streetPricePercentage",
      "userCountry",
      "folderName",
      "checkedZones",
      "allFolder",
      "zoneFolderList",
      "folderid",
      "renovated",

    ]),
    ...mapState("n_auction", ["streetPriceSaved"]),
    ...mapGetters("n_mapping", ["priceMq"]),

    orderedRegionList() {
      if (this.regionList) {
        return this.regionList.sort((a, b) => {
          if (b.city > a.city) {
            return -1;
          }
          return 1;
        });
      }
    },

    showBinOnlyIfThereIsOneOutdated() {
      //if (this.showBinIcon === true) {
      let onlyOne = this.buildingList.filter(function (p) {
        return p.broken_link === 1;
      });
      return onlyOne.length > 0 ? true : false;
      //}
    },
  },

  methods: {
    ...mapActions("n_mapping", [
      "removeCheckBrokenLink",
      "regionByUser",
      "zoneByCity",
      "buildingByZone",
      "tabOn",
      "saveCustomRangeData",
      "deleteCustomRange",
      "clearForm",
      "sendMappingData",
      "lastMapping",
      "exportExcel",
      "deleteBuilding",
      "notClone",
      "createOperation",
      "activateDeactivate",
      "checkAds",
      "deleteAdsOutdated",
      "changeStatus",
      "deleteZone",
      "allZoneByCity",
      "editZoneData",
      "retrieveMappedBuilding",
      "reloadBuildings",
      "saveFolder",
      "changeFolder",
      "allFolderByCity",
      "deleteFolder"

    ]),
    ...mapActions("n_auction", ["saveStreetPriceInAuction"]),
    ...mapMutations("n_mapping", ["SET_DATA"]),


    showTradesMap() {
      this.tradeMap = !this.tradeMap
      this.standardMap = !this.standardMap
    },



    whichPortal(payload) {
      // if(payload.indexOf('casa.it') > 0)
      // {
      //   return 'casa.it';
      // }
      // if(payload.indexOf('immobiliare.it') > 0)
      // {
      //   return 'immobiliare.it';
      // }
      // if(payload.indexOf('idealista.it') > 0)
      // {
      //   return 'idealista.it';
      // }
      //
      // if(payload.indexOf('pisos.com') > 0)
      // {
      //   return 'pisos.com';
      // }
      //
      // if(payload.indexOf('fotocasa.es') > 0)
      // {
      //   return 'fotocasa.es';
      // }

      return "link";
    },
    isClone(data) {
      if (data == 1) {
        return 'abtg__td-isclone'
      }


    },
    getPriceMq(price, mq) {
      if(price !== undefined)
      {
        if (price.toString().includes(".")) {
          price = price.replace(".", "");
        }

        let v = Math.round(price / mq);
        return this.FORMAT_PRICE(v);
      }

    },

    showZoneName(z) {
      let zone = z.zone != null ? z.zone : "";
      let macrozone =
          z.macrozone != null ? (z.zone != null ? " - " : "") + z.macrozone : "";
      let microzone =
          z.microzone != null
              ? (z.macrozone != null ? " - " : "") + z.microzone
              : "";
      let wholeZone = zone + macrozone + microzone;
      if (wholeZone.length > 28) {
        return wholeZone.substr(0, 28) + "...";
      }
      return wholeZone;
    },

    showZoneNameHashtag(z) {
      let zone = z.zone != null ? z.zone : "";
      let macrozone =
          z.macrozone != null ? (z.zone != null ? " - " : "") + z.macrozone : "";
      let microzone =
          z.microzone != null
              ? (z.macrozone != null ? " - " : "") + z.microzone
              : "";
      let wholeZone = zone + macrozone + microzone;

      return wholeZone.replaceAll(" ", "");
    },

    showModal(modalName, type) {

      switch (type) {
        case 'new':
          this.localfolderName = '';
          break;
        case 'old':
          this.editFolder = true;
          break;
      }
      this.$modal.show(modalName);
    },

    setZoneToEdit(modalName) {
      this.$modal.show(modalName);
    },

    editBuilding(data) {
      this.SET_DATA({
        name: "formData",
        data: data,
      });
      this.showModal("m-building");
    },

    newBuilding() {
      this.clearForm();
      this.showModal("m-building");
    },

    closeModal(modalName) {
      this.SET_DATA({
        name: "idToDelete",
        data: null,
      });
      this.SET_DATA({
        name: "idZoneToDelete",
        data: null,
      });
      this.$modal.hide(modalName);
      this.editFolder = false;
    },

    retrieveMqRange(mqRange, customRange, index) {
      this.SET_DATA({
        name: "activateLoading",
        data: true,
      });
      mqRange =
          mqRange || mqRange === 0
              ? mqRange
              : customRange.min + "," + customRange.max;
      let payload = this.zoneInfo;
      payload.range = mqRange;
      this.buildingByZone({z: payload});
      this.tabOn({
        mqRange: mqRange,
        index: index,
      }); // tab active (custom included)
    },

    setIdToDelete(id) {
      this.SET_DATA({
        name: "idToDelete",
        data: id,
      });
      this.showModal("m-delete");
    },
    setIdToNotClone(id) {
      this.SET_DATA({
        name: "idNotClone",
        data: id,
      });
      this.notClone();

    },
    setMapAndZoneToDelete(id) {
      this.SET_DATA({
        name: "idZoneToDelete",
        data: id,
      });
      this.showModal("m-delete");
    },

    deleteResource() {
      if (this.idZoneToDelete) {
        this.deleteZone(this.selectedZone);
      } else {
        this.deleteBuilding();
      }
    },

    updateMap() {
      // this.$router.push({path: '/mapping/search/' + this.zoneInfo.id + '/' + this.zoneInfo.region});
      window.location.href =
          "/mapping/search/" + this.zoneInfo.id + "/" + this.zoneInfo.region;
    },

    isThisLinkActive(payload) {
      if (this.activeAllZone) {
        return "";
      }
      if (
          this.zoneInfo &&
          this.zoneInfo.zone == payload.zone &&
          this.zoneInfo.macrozone == payload.macrozone &&
          this.zoneInfo.microzone == payload.microzone
      ) {
        return "abtg-zone-active";
      }
    },

    setMappingZone(payload) {
      this.zoneList.forEach((zone) => {
        if (zone.id === parseInt(payload.id)) {
          this.SET_DATA({
            name: "zoneInfo",
            data: zone,
          });
        }
      });
    },
    labelRenovation(payload) {
      switch (payload.renovated) {
        case 0:
          return "-";
        case 1:
          return "sì";
        case 2:
          return "no";
        case 3:
          return "ni";
      }
    },



    updateBuildingInline(building) {
      this.SET_DATA({
        name: "formData",
        data: building,
      });
      this.sendMappingData();
    },

    showAddressInput(id, focus) {
      let input = eval(`this.$refs.addressInput${id}`)[0];

      eval(`this.$refs.addressText${id}`)[0].classList.toggle("hidden");
      input.classList.toggle("hidden");

      if (focus) {
        input.focus();
      }
    },

    showFloorInput(id, focus) {
      let input = eval(`this.$refs.floorInput${id}`)[0];

      eval(`this.$refs.floorText${id}`)[0].classList.toggle("hidden");
      input.classList.toggle("hidden");

      if (focus) {
        input.focus();
      }
    },

    showRoomsInput(id, focus) {
      let input = eval(`this.$refs.roomsInput${id}`)[0];

      eval(`this.$refs.roomsText${id}`)[0].classList.toggle("hidden");
      input.classList.toggle("hidden");

      if (focus) {
        input.focus();
      }
    },

    showMqInput(id, focus) {
      let input = eval(`this.$refs.mqInput${id}`)[0];

      eval(`this.$refs.mqText${id}`)[0].classList.toggle("hidden");
      input.classList.toggle("hidden");

      if (focus) {
        input.focus();
      }
    },

    showPriceInput(id, focus) {
      let input = eval(`this.$refs.priceInput${id}`)[0];

      eval(`this.$refs.priceText${id}`)[0].classList.toggle("hidden");
      input.classList.toggle("hidden");

      if (focus) {
        input.focus();
      }
    },

    showRenovatedSelection(building) {
      this.SET_DATA({
        name: "formData",
        data: building,
      });

      let list = Object.entries(this.$refs).filter((item, index) => {
        if (/^renovated/.test(item[0])) {
          return item;
        }
      });

      if (list && list.length > 0) {
        list.forEach((item) => {
          if (item.length > 0 && item[0].includes(building.id.toString())) {
            return;
          }

          if (
              item.length > 0 &&
              item[0].includes("Text") &&
              item[1] &&
              item[1].length > 0
          ) {
            item[1][0].classList.remove("hidden");
          }

          if (
              item.length > 0 &&
              item[0].includes("Selection") &&
              item[1] &&
              item[1].length > 0
          ) {
            item[1][0].classList.add("hidden");
          }
        });
      }

      eval(`this.$refs.renovatedText${building.id}`)[0].classList.toggle(
          "hidden"
      );
      eval(`this.$refs.renovatedSelection${building.id}`)[0].classList.toggle(
          "hidden"
      );
    },

    showPencilIcon(target) {
      target.parentElement
          .getElementsByClassName("fa-pencil-alt")[0]
          .classList.toggle("hidden");
    },

    checkIfHasExist() {
      if (this.$route.hash) {
        let element = document.getElementById(
            `${this.$route.hash.replaceAll("%20", "").replace("#", "")}`
        );
        element ? element.click() : null;
      }
    },

    removeAllSelectedZones() {
      [...document.getElementsByClassName("abtg-zone-selected")].forEach(
          (zone) => {
            zone.classList.remove("abtg-zone-selected");
          }
      );
    },

    goToUrl(folderid) {

      window.location.href = `/services/compravendita/?cityId=${this.selectedZone.cityId}&city=${this.selectedZone.city}&folderId=${folderid}`;


    },

    handleUrl(what) {
      let url = new URL(window.location.href);
      return url.searchParams.get(what);
    },

    changeZoneByUrl() {
      if (this.handleUrl('city') !== null && this.handleUrl('cityId') !== null) {
        if (this.handleUrl('folderId') !== null) {
          this.localfolderId = this.handleUrl('folderId');
        }
        this.selectedZone.city = this.handleUrl('city');
        this.selectedZone.cityId = this.handleUrl('cityId');
        this.zoneByCity({
          city: this.handleUrl('city'),
          cityId: this.handleUrl('cityId'),
          folderId: this.localfolderId = this.handleUrl('folderId')
        });
        setTimeout(() => {
          if (this.localfolderId !== '0' && this.allFolder) {
            this.allFolder.forEach((folder) => {
              if (this.localfolderId == folder.id) {
                this.localfolderName = folder.name;
              }
            });
          }


        }, 1500)
      }

    },


    createFolder(payload) {
      if (this.editFolder) {
        this.SET_DATA({
          name: "folderName",
          data: payload,
        },);
        this.SET_DATA({
          name: "folderId",
          data: this.localfolderId,
        },);
        this.saveFolder();
      } else {
        this.SET_DATA({
          name: "folderName",
          data: payload,
        },);
        this.SET_DATA({
          name: "checkedZones",
          data: this.zoneChecked,
        },);

        this.SET_DATA({
          name: "folderId",
          data: null,
        },);
        this.saveFolder();
      }


    },

    changeFolderlocal(id) {
      this.SET_DATA({
        name: "checkedZones",
        data: this.zoneChecked,
      },);
      this.SET_DATA({
        name: "folderId",
        data: id,
      },);
      this.changeFolder();
    },

    setFolderForDelete() {
      this.SET_DATA({
        name: "folderId",
        data: this.localfolderId,
      },);

      this.deleteFolder();


    },


  },
};
</script>

